export default __webpack_public_path__ + "static/box-8e1963f37c693bb0d5ce3ddbf3bc2eb5.png";